import { RouteObject } from 'react-router';
import { Outlet } from 'react-router';
import { ProtectedRoute } from '@/routes/ProtectedRoute';
import { PatientsPage } from './components/PatientsPage';
import { NewPatientRequestPage } from './components/NewPatientRequestPage';
import { EditPatientRequestPage } from './components/EditPatientRequestPage';
import { PatientProfile } from './components/patient-profile/PatientProfile';
import { Permission } from '@/utils/roles';

export const patientRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute requiredPermissions={[Permission.VIEW_PATIENTS]}>
        <Outlet />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <PatientsPage /> },
      { path: 'request', element: <NewPatientRequestPage /> },
      { path: 'edit/:patientId', element: <EditPatientRequestPage /> },
      {
        path: ':patientId/facesheets/:facesheetRequestId',
        element: <PatientProfile />,
      },
      { path: ':patientId', element: <PatientProfile /> },
    ],
  },
];
